import React, { useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Dropdown } from "primereact/dropdown";
import ReportsConstants from "reports/utils/ReportsConstants";
import ReportsMessages from "reports/intl/ReportsMessages";
import { getReportTypeMessage } from "reports/shared/utils/util";

const { ALL, REPORT_TYPES } = ReportsConstants;

const ReportTypeFilter = ({ filterApplyCallback, value }) => {
  const { formatMessage } = useIntl();

  const handleChange = useCallback(
    (evt) => {
      filterApplyCallback(evt.value);
    },
    [filterApplyCallback]
  );

  const ddlOpts = useMemo(() => {
    const allOption = { id: ALL, name: formatMessage(ReportsMessages.all) };
    const reportTypeOptions = Object.values(REPORT_TYPES)
      .map((reportType) => {
        const message = getReportTypeMessage(reportType);
        return message
          ? { id: reportType, name: formatMessage(message) }
          : null;
      })
      .filter(Boolean);
    return [allOption, ...reportTypeOptions];
  }, [formatMessage]);

  return (
    <Dropdown
      dataKey="reportType"
      onChange={handleChange}
      optionLabel="name"
      options={ddlOpts}
      optionValue="id"
      resetFilterOnHide
      value={value}
    />
  );
};

ReportTypeFilter.propTypes = {
  filterApplyCallback: PropTypes.func,
  value: PropTypes.string,
};

export default ReportTypeFilter;
